import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-lg font-bold text-background-50">
                白
              </span>
              <span className="text-base font-bold tracking-wide text-foreground-950">国模白露</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              专注于高质量模特写真摄影作品的展示与欣赏平台，为摄影爱好者与模特粉丝提供丰富的图库浏览体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">
              <Link to="/category/fashion" className="transition-colors hover:text-primary-600">
                作品分类
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.map((category) => (
                <li key={category.id}>
                  <Link
                    to={`/category/${category.id}`}
                    className="text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">
              <Link to="/favorites" className="transition-colors hover:text-primary-600">
                快捷入口
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-foreground-600 transition-colors hover:text-primary-600">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/favorites" className="text-foreground-600 transition-colors hover:text-primary-600">
                  我的收藏
                </Link>
              </li>
              <li>
                <Link to="/list/fashion" className="text-foreground-600 transition-colors hover:text-primary-600">
                  作品列表
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-600 transition-colors hover:text-primary-600">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">
              <Link to="/about" className="transition-colors hover:text-primary-600">
                联系我们
              </Link>
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500" />
                contact@guomobailu.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-primary-500" />
                微信公众号：国模白露
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-weibo-line text-primary-500" />
                微博：@国模白露图库
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© 2024 国模白露模特写真作品集 · 保留所有权利</p>
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
            <Link to="/about" className="transition-colors hover:text-primary-600">
              隐私政策
            </Link>
            <Link to="/about" className="transition-colors hover:text-primary-600">
              服务条款
            </Link>
            <span>本站图片仅用于作品展示与欣赏</span>
          </div>
        </div>
      </div>
    </footer>
  );
}